<template>
  <div class="gestao-equipas-container">
    <div v-if="!currentView">
      <h1>Gestão de Equipas</h1>

      <div class="button-group">
        <button @click="showForm('subscribe')" class="action-btn">
          Inscrever
        </button>
        <button @click="showForm('alterar')" class="action-btn">Alterar</button>
        <button @click="showForm('remover')" class="action-btn">
          Cancelar
        </button>
      </div>

      <ul>
        <li v-for="(user, index) in users" :key="index" class="user-item">
          {{ user.dsr_id }} - {{ user.dsr_name }}
        </li>
      </ul>
    </div>

    <!-- Formulário Inscrição -->
    <div v-if="currentView === 'subscribe'">
      <h2>Inscrição de Colaboradores</h2>
      <form @submit.prevent="submitSubscribe">
        <div class="form-group">
          <div class="btn-wrap">
            <button
              type="button"
              class="action-btn dsr-type"
              @click="subscribe.dsr_type = '1'"
            >
              Vendedor
            </button>
          </div>
          <div class="btn-wrap">
            <button
              type="button"
              class="action-btn dsr-type"
              @click="subscribe.dsr_type = '2'"
            >
              Chefe de Vendas / Vendedor
            </button>
          </div>
          <div class="btn-wrap">
            <button
              type="button"
              class="action-btn dsr-type"
              @click="subscribe.dsr_type = '3'"
            >
              Chefe de Vendas
            </button>
          </div>
          <div v-if="!subscribe.dsr_type">
            <button
              type="button"
              @click="cancel"
              class="action-btn cancel-btn margin"
            >
              Voltar
            </button>
          </div>
        </div>
        <div v-if="subscribe.dsr_type">
          <div class="form-group">
            <label>Código de Vendedor</label>
            <input
              type="text"
              v-model="subscribe.code"
              placeholder="Código de Vendedor"
            />
            <label v-if="subscribe.dsr_type !== '3'">Chefe de vendas</label>
            <select
              v-if="subscribe.dsr_type !== '3'"
              v-model="subscribe.leader_id"
            >
              <option value="Sem equipa">Sem equipa</option>
              <option
                v-for="leader in leaders"
                :key="leader.leader_id"
                :value="leader.leader_id"
              >
                {{ leader.dsr_name }}
              </option>
            </select>

            <label>Mês de início</label>
            <select v-model="subscribe.ym_start">
              <option
                v-for="(month, index) in months"
                :value="index + 1"
                :key="index"
              >
                {{ month }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Nome</label>
            <input
              type="text"
              v-model="subscribe.first_name"
              placeholder="Nome"
            />
            <label>Apelido</label>
            <input
              type="text"
              v-model="subscribe.last_name"
              placeholder="Apelido"
            />
          </div>

          <div class="form-group">
            <label>Endereço de email</label>
            <input
              type="email"
              v-model="subscribe.email"
              placeholder="Endereço de email"
            />
            <label>Nº de telemóvel</label>
            <input
              type="text"
              v-model="subscribe.phone"
              placeholder="Nº de telemóvel"
            />
          </div>

          <div class="form-group">
            <label>Data de nascimento</label>
            <input type="date" v-model="subscribe.birth_date" />
          </div>

          <div
            v-if="subscribe.dsr_type === '2' || subscribe.dsr_type === '3'"
            class="form-group"
          >
            <label>Vendedores a associar</label>
            <div v-for="user in users" :key="user.dsr_id">
              <input
                type="checkbox"
                :value="user.dsr_id"
                v-model="subscribe.sub_associatedVendors"
              />
              {{ user.dsr_name }}
            </div>
          </div>

          <div class="form-group">
            <label>Observações</label>
            <textarea
              v-model="subscribe.notes"
              placeholder="Observações"
            ></textarea>
          </div>
          <button type="submit" class="action-btn">Submeter</button>
          <button type="button" @click="cancel" class="action-btn cancel-btn">
            Voltar
          </button>
        </div>
      </form>
    </div>

    <!-- Formulário Alterar -->
    <div v-if="currentView === 'alterar'">
      <h2>Alterar DSR</h2>
      <form @submit.prevent="submitAlterar">
        <div class="form-group">
          <div class="btn-wrap">
            <button
              type="button"zclass="action-btn dsr-type"
              @click="alterar.alt_dsr_type = '1'"
            >
              Vendedor
            </button>
          </div>
          <div class="btn-wrap">
            <button
              type="button"
              class="action-btn dsr-type"
              @click="alterar.alt_dsr_type = '2'"
            >
              Chefe de Vendas / Vendedor
            </button>
          </div>
          <div class="btn-wrap">
            <button
              type="button"
              class="action-btn dsr-type"
              @click="alterar.alt_dsr_type = '3'"
            >
              Chefe de Vendas
            </button>
          </div>
          <div v-if="!alterar.alt_dsr_type">
            <button
              type="button"
              @click="cancel"
              class="action-btn cancel-btn margin"
            >
              Voltar
            </button>
          </div>
        </div>

        <div v-if="alterar.alt_dsr_type">
          <div class="form-group" v-if="alterar.alt_dsr_type === '1'">
            <label>Vendedor</label>
            <select
              v-model="alterar.dsr_id"
              @change="populatechangeForm(alterar.alt_dsr_type)"
            >
              <option
                v-for="user in users"
                :value="user.dsr_id"
                :key="user.dsr_id"
              >
                {{ user.dsr_name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Chefe de vendas</label>
            <select v-model="alterar.leader_id">
              <option value="Sem equipa">Sem equipa</option>
              <option
                v-for="leader in leaders"
                :key="leader.leader_id"
                :value="leader.leader_id"
              >
                {{ leader.dsr_name }}
              </option>
            </select>
            <label>Código de Vendedor</label>
            <input
              type="text"
              v-model="alterar.code"
              placeholder="Código de Vendedor"
            />
            <label>Mês de início</label>
            <select v-model="alterar.ym_start">
              <option
                v-for="(month, index) in months"
                :value="index + 1"
                :key="index"
              >
                {{ month }}
              </option>
            </select>
          </div>

          <div
            v-if="alterar.alt_dsr_type === '2' || alterar.alt_dsr_type === '3'"
            class="form-group"
          >
            <label>Vendedores a associar</label>
            <div v-for="(user, index) in users" :key="user.dsr_id">
              <input
                type="checkbox"
                :value="user.dsr_id"
                v-model="alterar.associatedVendors"
              />
              {{ user.dsr_name }}
            </div>
          </div>

          <div class="form-group">
            <label>Observações</label>
            <textarea
              v-model="alterar.notes"
              placeholder="Observações"
            ></textarea>
          </div>
          <button type="submit" class="action-btn">Alterar</button>
          <button type="button" @click="cancel" class="action-btn cancel-btn">
            Voltar
          </button>
        </div>
      </form>
    </div>

    <!-- Formulário Cancelar -->
    <div v-if="currentView === 'remover'">
      <h2>Cancelar DSR</h2>
      <form @submit.prevent="submitCancelar">
        <div class="form-group">
          <div class="btn-wrap">
            <button
              type="button"
              class="action-btn dsr-type"
              @click="cancelar.dlt_dsr_type = '1'"
            >
              Vendedor
            </button>
          </div>
          <div class="btn-wrap">
            <button
              type="button"
              class="action-btn dsr-type"
              @click="cancelar.dlt_dsr_type = '3'"
            >
              Chefe de Vendas
            </button>
          </div>
          <div v-if="!cancelar.dlt_dsr_type">
            <button
              type="button"
              @click="cancel"
              class="action-btn cancel-btn margin"
            >
              Voltar
            </button>
          </div>
        </div>
        <div v-if="cancelar.dlt_dsr_type">
          <div class="form-group" v-if="cancelar.dlt_dsr_type === '1'">
            <label>Vendedor</label>
            <select
              v-model="cancelar.dsr_id"
              @change="populatedeleteForm(cancelar.dsr_id)"
            >
              <option
                v-for="user in users"
                :value="user.dsr_id"
                :key="user.dsr_id"
              >
                {{ user.dsr_name }}
              </option>
            </select>
          </div>

          <div
            class="form-group"
            v-if="
              cancelar.dlt_dsr_type === '2' || cancelar.dlt_dsr_type === '3'
            "
          >
            <label>Chefe de vendas</label>
            <select
              v-model="cancelar.dsr_id"
              @change="populateLeaderForm(cancelar.dsr_id)"
            >
              <option
                v-for="leader in leaders"
                :key="leader.dsr_id"
                :value="leader.dsr_id"
              >
                {{ leader.dsr_name }}
              </option>
            </select>
          </div>

          <!-- Restante do formulário -->
          <div class="form-group">
            <label>Mês de fim</label>
            <select v-model="cancelar.ym_end">
              <option
                v-for="(month, index) in months"
                :value="index + 1"
                :key="index"
              >
                {{ month }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Observações</label>
            <textarea
              v-model="cancelar.notes"
              placeholder="Observações"
            ></textarea>
          </div>

          <button type="submit" class="action-btn">Cancelar</button>
          <button type="button" @click="cancel" class="action-btn cancel-btn">
            Voltar
          </button>
        </div>
      </form>
    </div>

    <div v-if="showingPopup" class="popup-overlay">
      <div class="popup">
        <p>{{ popupMessage }}</p>
        <button class="btn-close" @click="closePopup">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      currentView: null,
      showingPopup: false,
      popupMessage: "",
      loading: false,
      users: [],
      dsrId: null,
      alteration_type: null,
      subscribe: {
        change_dsr_id: "0",
        dsr_type: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        code: "",
        birth_date: "",
        leader_id: "",
        notes: "",
        ym_start: "",
        ym_end: "",
        sub_associatedVendors: [],
      },
      leaders: [],
      alterar: {
        change_dsr_id: "0",
        alt_dsr_type: "",
        dsr_id: "",
        leader_id: "",
        code: "",
        ym_start: "",
        associatedVendors: [],
        notes: "",
      },
      cancelar: {
        change_dsr_id: "0",
        dlt_dsr_type: "",
        dsr_id: "",
        leader_id: "",
        ym_end: "",
        notes: "",
      },
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },

  mounted() {
    this.fetchLeader();
    this.fetchUsers();
    this.fetchDsrId();
  },
  methods: {
    populatechangeForm(dsr_id) {
      const selectedUser = this.users.find((user) => user.dsr_id === dsr_id);
      if (selectedUser) {
        this.alterar.first_name = selectedUser.first_name;
        this.alterar.last_name = selectedUser.last_name;
        this.alterar.email = selectedUser.email;
        this.alterar.phone = selectedUser.phone;
        this.alterar.birth_date = selectedUser.birth_date;
      }
    },
    populatedeleteForm(dsr_id) {
      const selectedUser = this.users.find((user) => user.dsr_id === dsr_id);
      if (selectedUser) {
        this.cancelar.first_name = selectedUser.first_name;
        this.cancelar.last_name = selectedUser.last_name;
        this.cancelar.email = selectedUser.email;
        this.cancelar.phone = selectedUser.phone;
        this.cancelar.birth_date = selectedUser.birth_date;
        this.cancelar.code = selectedUser.code;
      }
    },
    showForm(form) {
      this.currentView = form;
      if (form === "subscribe") {
        this.subscribe.alteration_type = 1;
      } else if (form === "alterar") {
        this.alterar.alteration_type = 2;
      } else if (form === "remover") {
        this.cancelar.alteration_type = 3;
      }
    },
    async fetchUsers() {
      this.loading = true;
      try {
        const response = await axios.get("app/getTeams");
        this.users = response.data.equipa || [];
        console.log(this.users);
      } catch (error) {
        this.showPopup("Erro ao carregar usuários.");
      } finally {
        this.loading = false;
      }
    },

    async fetchLeader() {
      this.leader = null;
      try {
        const response = await axios.get("app/getLeader");

        if (response.data.leader && response.data.leader.length > 0) {
          this.leaders = response.data.leader;
        } else {
          console.warn("Nenhum líder encontrado");
        }
      } catch (error) {
        console.error("Erro ao buscar líder:", error);
      }
    },

    async fetchDsrId() {
      try {
        const response = await axios.get("app/getDsrId");
        this.dsrId = response.data.dsr_id;
      } catch (error) {
        this.showPopup("Erro ao carregar DSR ID.");
      }
    },
    async submitSubscribe() {
      this.loading = true;
      try {
        const payload = {
          change_dsr_id: "0",
          dsr_id: this.dsrId,
          dsr_type: this.subscribe.dsr_type,
          first_name: this.subscribe.first_name,
          last_name: this.subscribe.last_name,
          email: this.subscribe.email,
          phone: this.subscribe.phone,
          code: this.subscribe.code,
          birth_date: this.subscribe.birth_date,
          leader_id: this.subscribe.leader_id,
          notes: this.subscribe.notes,
          ym_start: String(this.subscribe.ym_start),
          ym_end: "0",
          alteration_type: this.subscribe.alteration_type,
          team:
            this.subscribe.dsr_type === "2" || this.subscribe.dsr_type === "3"
              ? this.subscribe.sub_associatedVendors
              : [],
        };
        await axios.post("app/InsDsrs", payload);
        this.showPopup("Inscrição submetida com sucesso!");
        this.fetchUsers();
        this.cancel();
      } catch (error) {
        this.showPopup("Erro ao fazer inscrição.");
      } finally {
        this.loading = false;
        // this.subscribe.alteration_type = null;
      }
    },
    async submitAlterar() {
      this.loading = true;
      try {
        if (
          this.alterar.alt_dsr_type === "2" ||
          this.alterar.alt_dsr_type === "3"
        ) {
          if (
            !this.alterar.leader_id ||
            this.alterar.leader_id === "" ||
            this.alterar.leader_id === "Sem equipa"
          ) {
            this.showPopup("Por favor, selecione um Chefe de Vendas.");
            this.loading = false;
            return; // Stop submission
          }
        }
        const payload = {
          change_dsr_id: this.alterar.dsr_id,
          first_name: this.alterar.first_name,
          last_name: this.alterar.last_name,
          phone: this.alterar.phone,
          email: this.alterar.email,
          birth_date: this.alterar.birth_date,
          dsr_type: this.alterar.alt_dsr_type,
          dsr_id: this.dsrId,
          leader_id: this.alterar.leader_id,
          code: this.alterar.code,
          ym_start: String(this.alterar.ym_start),
          team: this.alterar.associatedVendors,
          notes: this.alterar.notes,
          alteration_type: this.alterar.alteration_type,
        };
        await axios.post("app/InsDsrs", payload);
        this.showPopup("Alteração submetida com sucesso!");
        this.fetchUsers();
        this.cancel();
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;
          if (errors.ym_start) {
            this.showPopup("Por favor, selecione o mês de início.");
          } else {
            const firstError = Object.values(errors)[0][0]; // Get first message
            this.showPopup(firstError);
          }
        } else {
          this.showPopup("Erro ao fazer alteração.");
        }
      } finally {
        this.loading = false;
      }
    },
    populateLeaderForm(dsr_id) {
      const selectedUser = this.users.find((user) => user.dsr_id === dsr_id);
      if (selectedUser) {
        this.cancelar.first_name = selectedUser.first_name;
        this.cancelar.last_name = selectedUser.last_name;
        this.cancelar.phone = selectedUser.phone;
        this.cancelar.email = selectedUser.email;
        this.cancelar.code = selectedUser.code;
        this.cancelar.birth_date = selectedUser.birth_date;
      }
    },
    async submitCancelar() {
      this.loading = true;

      if (!this.cancelar.ym_end) {
        this.showPopup("Por favor, selecione um mês de fim.");
        this.loading = false;
        return;
      }
      try {
        const payload = {
          change_dsr_id: this.cancelar.dsr_id,
          dsr_type: this.cancelar.dlt_dsr_type,
          first_name: this.cancelar.first_name,
          last_name: this.cancelar.last_name,
          dlt_dsr_type: this.cancelar.dsr_type,
          phone: this.cancelar.phone,
          email: this.cancelar.email,
          birth_date: this.cancelar.birth_date,
          code: this.cancelar.code,
          dsr_id: this.dsrId,
          leader_id: this.cancelar.leader_id,
          ym_start: "0",
          ym_end: String(this.cancelar.ym_end),
          notes: this.cancelar.notes,
          alteration_type: this.cancelar.alteration_type,
        };
        await axios.post("app/InsDsrs", payload);
        this.showPopup("Cancelamento submetido com sucesso!");
        this.fetchUsers();
        this.cancel();
      } catch (error) {
        this.showPopup("Erro ao fazer cancelamento.");
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.currentView = null;
      this.subscribe = {
        dsr_type: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        code: "",
        birth_date: "",
        leader_id: "",
        notes: "",
        ym_start: "",
        ym_end: "",
        alteration_type: "",
        sub_associatedVendors: [],
      };
      this.alterar = {
        dsr_id: "",
        alt_dsr_type: "",
        leader_id: "",
        code: "",
        birth_date: "",
        ym_start: "",
        associatedVendors: [],
        notes: "",
        alteration_type: "",
      };
      this.cancelar = {
        dsr_id: "",
        dlt_dsr_type: "",
        leader_id: "",
        birth_date: "",
        ym_start: "",
        ym_end: "",
        notes: "",
        alteration_type: "",
      };
    },
    showPopup(message) {
      this.popupMessage = message;
      this.showingPopup = true;
    },
    closePopup() {
      this.showingPopup = false;
      this.popupMessage = "";
    },
  },
  created() {
    this.fetchUsers();
  },
};
</script>

<style>
.gestao-equipas-container {
  padding: 20px;
  max-width: 800px;
  margin: auto;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 1.75rem;
  text-align: center;
}

h2 {
  margin-bottom: 2rem;
}

ul {
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
}

.user-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0;
}

.button-group {
  text-align: center;
  margin-bottom: 20px;
}

.action-btn {
  padding: 10px 15px;
  margin: 5px;
  background-color: #ff7f50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.cancel-btn {
  background-color: #ccc;
}
.cancel-btn.margin {
  margin-left: 12%;
}
.action-btn:hover {
  background-color: #ff5722;
}

.action-btn.cancel-btn:hover {
  background-color: #999;
}
.action-btn.dsr-type {
  font-size: small;
  width: 75%;
}
.btn-wrap {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  justify-content: center;
}
.form-group {
  margin-bottom: 15px;
}

input[type="text"],
input[type="email"],
input[type="date"],
select,
textarea {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

textarea {
  height: 80px;
}

.remove-btn {
  background-color: #ffffff;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.icon-size {
  width: 20px;
}

/* Pop-up overlay and styling */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  max-width: 80%;
  text-align: center;
}

.popup p {
  color: rgb(0, 0, 0);
  margin-bottom: 20px;
}

.btn-close {
  background-color: orange;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.btn-close:hover {
  background-color: #e96d2f;
}
</style>
